import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as signalR from "@microsoft/signalr";
import { Observable, Subject, BehaviorSubject} from 'rxjs';
import { OktaAuthService } from '@common_libraries/Services/login/oktaAuth.service';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SignalrService {
  private hubConnection: signalR.HubConnection
  private _signalRConnection = new BehaviorSubject<signalR.HubConnection>(null);
  signalrConnection$ = this._signalRConnection.asObservable().pipe(
                                              filter(user => user !== null),
                                              distinctUntilChanged());

  public hubUrl: string = '';
  constructor(
    private okta: OktaAuthService) { 

  }

  public startConnection(){
    this.okta.oktaAuth.tokenManager.get('accessToken').then((token) => {
      if (token) {
        //$.signalR.ajaxDefaults.headers = { Authorization: "Bearer " + token };
        this.hubConnection = new signalR.HubConnectionBuilder()
                                .withUrl(environment.webApiUrl + '/proxyHub',
                                { 
                                  withCredentials: true, accessTokenFactory: async() => 
                                    {
                                      var tokenInner = await this.okta.oktaAuth.tokenManager.get('accessToken');
                                      
                                      //We have to cast tokenInner to any, so that we can compile
                                      //Okta's internal type definitions are out of sync with the actual object properties in 7.2.0
                                      //Pretty awesome stuff
                                      return (<any>tokenInner).accessToken;
                                    }
                                })
                                .withAutomaticReconnect()
                                //.configureLogging(signalR.LogLevel.Trace)
                                .build();
        this.hubConnection
          .start()
          .then(() => { this._signalRConnection.next(this.hubConnection);})
          .catch(err => console.log('Error while starting connection: ' + err));
      }
    });
  }

  public getHubConnection() : signalR.HubConnection { 
    return this.hubConnection;
  }

  public stopConnection = () => {
    this.hubConnection.stop();
    console.log('stopping hub connection');
  }

  public invoke(target: string, callback: (res: any) => void, ...content: any){
    this.hubConnection.invoke(target, ...content).then(callback).catch((err)=>{
      if(this.hubConnection.state !== signalR.HubConnectionState.Connected){
        if(this.hubConnection.state === signalR.HubConnectionState.Disconnected ||
          this.hubConnection.state === signalR.HubConnectionState.Disconnecting){
            this.startConnection();
          }
        }
    });
  } 
  
  public listen(target: string) : Observable<any>  {
    const subject: Subject<any> = new Subject<any>();
    //console.log('Subscribing to: ' + target + " on the following connection.", this.hubConnection);
    this.hubConnection.on(target, data => {
      subject.next(data);
    });
    return subject;
  }

}

